/** #404: labels for the insurer activity log's event catalogue. */

/** Readable names for catalogue events. An unknown key shows as itself. */
export const EVENT_LABELS: Record<string, string> = {
  'staff.login': 'Signed in',
  'staff.login_failed': 'Failed sign-in',
  'staff.logout': 'Signed out',
  'staff.invited': 'Team member added',
  'staff.removed': 'Team member removed',
  'staff.suspended': 'Team member suspended',
  'staff.reactivated': 'Team member reactivated',
  'staff.password_reset': 'Password reset',
  'staff.role_changed': 'Role changed',
  'staff.member_updated': 'Team member edited',
  'staff.invitation_resent': 'Invitation resent',
  'staff.custom_role_saved': 'Custom role saved',
  'staff.custom_role_deleted': 'Custom role deleted',
  'staff.permission_denied': 'Permission denied',
  'quote.received': 'Quote received',
  'quote.assigned': 'Quote assigned',
  'quote.accepted': 'Quote accepted',
  'quote.declined': 'Quote declined',
  'quote.counter_offered': 'Counter-offer',
  'quote.referred': 'Quote referred',
  'uw.decision_overridden': 'Decision overridden',
  'policy.issued': 'Policy issued',
  'policy.status_changed': 'Policy status changed',
  'policy.endorsed': 'Policy endorsed',
  'policy.cancelled': 'Policy cancelled',
  'policy.renewal_offered': 'Renewal offered',
  'claim.registered': 'Claim registered',
  'claim.assigned': 'Claim assigned',
  'claim.status_changed': 'Claim status changed',
  'claim.reserve_set': 'Reserve set',
  'claim.authorised': 'Claim authorised',
  'claim.rejected': 'Claim rejected',
  'claim.settled': 'Claim settled',
  'claim.authorisation_denied': 'Authorisation refused',
  'claim.document_decision': 'Document decision',
  'config.api_config_changed': 'API configuration changed',
  'config.api_test_run': 'API test run',
  'config.insurer_status_changed': 'Company status changed',
  'config.field_mapping_changed': 'Field mapping changed',
  'config.profile_updated': 'Company profile updated',
  'config.commission_schedule_created': 'Commission schedule created',
  'config.commission_schedule_updated': 'Commission schedule updated',
  'config.commission_schedule_activated': 'Commission schedule activated',
  'config.commission_schedule_retired': 'Commission schedule retired',
  'config.commission_schedule_approved': 'Commission schedule approved',
  'config.product_created': 'Product created',
  'config.product_updated': 'Product updated',
  'config.product_state_changed': 'Product state changed',
  'config.product_retired': 'Product retired',
  'config.broker_request_approved': 'Broker request approved',
  'config.broker_request_rejected': 'Broker request rejected',
  'config.broker_status_changed': 'Broker connection changed',
  'config.broker_products_changed': 'Broker products changed',
  'audit.exported': 'Activity log exported',
  'audit.retention_purged': 'Retention purge',
  'audit.integrity_failed': 'Integrity check failed',
};

export const eventLabel = (key: string) => EVENT_LABELS[key] ?? key;
